import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  ReferenceInput,
  SelectInput,
  required,
} from 'react-admin';
import { MediaInput } from '../../components/inputs';

export const CategoryCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="slug" fullWidth helperText="Автоматически генерируется из названия, если не указан" />
      <TextInput source="description" multiline rows={4} fullWidth />
      
      <MediaInput 
        source="imageId" 
        label="Изображение категории" 
        multiple={false}
        accept="image/*"
        helperText="Выберите изображение для категории"
      />
      
      <MediaInput 
        source="iconId" 
        label="Иконка категории" 
        multiple={false}
        accept="image/*"
        helperText="Выберите иконку для категории"
      />
      
      <ReferenceInput source="parentId" reference="categories" label="Родительская категория">
        <SelectInput optionText="name" emptyText="Нет родителя (корневая категория)" />
      </ReferenceInput>
      
      <NumberInput source="sortOrder" defaultValue={0} />
      <BooleanInput source="isActive" defaultValue={true} />
      
      {/* SEO поля */}
      <TextInput source="metaTitle" label="SEO заголовок" fullWidth />
      <TextInput source="metaDescription" label="SEO описание" multiline rows={3} fullWidth />
      <TextInput source="metaKeywords" label="SEO ключевые слова" fullWidth helperText="Ключевые слова через запятую" />
    </SimpleForm>
  </Create>
);
